// let url = "http://192.168.1.63:30000"  // xyh
// let url = "http://192.168.1.108:30000"  // yc
// let url = "https://my.515ugx.com:20082"  // cs
let url = "https://my.yccngx.com"  // zs
const api = {
  usageDuration: url + "/api/diagnosis/industrialElement/usageDuration",
  activation: url + "/api/diagnosis/industrialElement/activation",
  getViewCountTrend: url + "/api/diagnosis/fourStarCloudUp/getViewCountTrend",
  popularApplications: url + "/api/diagnosis/industrialElement/popularApplications",
  orderType: url + "/api/diagnosis/industrialElement/orderType",
  allCount: url + "/api/diagnosis/cockFourStars/allCount",
  orderDetail: url + "/api/diagnosis/cockFourStars/orderDetail",
  xYNumber: url + "/api/diagnosis/cockFourStars/xYNumber",
  industryCapacityAnalysis: url + "/api/diagnosis/fourStarCloudUp/industryCapacityAnalysis",
  regionalCapacityAnalysis: url + "/api/diagnosis/fourStarCloudUp/regionalCapacityAnalysis",
  equipmentTypeCapacityAnalysis: url + "/api/diagnosis/fourStarCloudUp/equipmentTypeCapacityAnalysis",
}
export default api
